import { Compass, Heart, MapPinned, ShieldCheck, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/api";

export default function Sobre() {
  return (
    <div data-testid="sobre-page" className="pt-32 pb-24">
      <div className="container-rotta">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-[#C6A762] mb-5">
            <span className="gold-divider" />
            <span className="text-[11px] tracking-[0.35em] uppercase">Sobre a ROTTA</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-[1.0]">
            Conectamos motociclistas aos
            <br />
            <span className="text-gold-gradient">melhores caminhos do Brasil.</span>
          </h1>
          <p className="text-[#B8B8B8] mt-5 leading-relaxed text-lg">
            A ROTTA nasceu para conectar motociclistas às melhores estradas, destinos e
            experiências do Brasil. Mais do que um catálogo de rotas, a plataforma reúne trajetos
            verificados, cidades, pontos de interesse, eventos e conteúdos produzidos por quem
            realmente vive a estrada. Nosso objetivo é facilitar o planejamento das viagens e
            fortalecer a comunidade do mototurismo brasileiro, com informações confiáveis,
            organizadas e constantemente atualizadas.
          </p>
        </div>

        <div className="mt-16 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="card-rotta p-10 flex items-center justify-center bg-[#0E0E0E]">
              <img src={ASSETS.logoFull} alt="ROTTA — Viva a Estrada" className="max-w-[260px] w-full" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <h2 className="font-display text-3xl md:text-4xl text-white">Nossos valores</h2>
            <div className="mt-8 grid sm:grid-cols-2 gap-5">
              <Value icon={<Sparkles size={16} />} title="Liberdade" desc="Viva sua própria rota. Sem rodeios, sem amarras." />
              <Value icon={<Compass size={16} />} title="Exploração" desc="Descubra novos lugares e novas histórias na estrada." />
              <Value icon={<MapPinned size={16} />} title="Conexão" desc="Encontre sua tribo na estrada e nas paradas." />
              <Value icon={<ShieldCheck size={16} />} title="Confiança" desc="Informações de quem realmente vive a estrada." />
              <Value icon={<Heart size={16} />} title="Experiência" desc="Mais que destinos — memórias para a vida toda." />
            </div>
          </div>
        </div>

        <div className="mt-20 card-rotta p-10 md:p-14 bg-gradient-to-br from-[#181818] to-[#101010]">
          <h2 className="font-display text-3xl md:text-4xl text-white max-w-3xl leading-tight">
            Uma <span className="text-gold-gradient">plataforma feita para a estrada.</span>
          </h2>
          <p className="text-[#B8B8B8] mt-5 max-w-3xl leading-relaxed">
            A ROTTA combina curadoria editorial, dados verificados e a inteligência da comunidade
            para entregar rotas que respeitam quem ama duas rodas. Estamos construindo o ecossistema
            premium do mototurismo brasileiro — do planejamento da viagem ao café da estrada.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/rotas" className="btn-gold px-6 py-3 rounded-full text-xs">Explorar Rotas</Link>
            <Link to="/#newsletter" data-testid="sobre-community-cta" className="btn-ghost px-6 py-3 rounded-full text-xs">Entrar para a comunidade</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Value({ icon, title, desc }) {
  return (
    <div className="border border-[#2a2a2a] rounded-xl p-5 hover:border-[#C6A762]/40 transition-colors">
      <div className="w-9 h-9 rounded-full grid place-items-center bg-[#C6A762]/10 text-[#C6A762] border border-[#C6A762]/30 mb-3">
        {icon}
      </div>
      <div className="font-display tracking-wider uppercase text-white text-sm">{title}</div>
      <div className="text-[#B8B8B8] text-sm mt-1.5 leading-relaxed">{desc}</div>
    </div>
  );
}
